"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v1Venue = void 0;
/**
 * v1's geometry as venues, for the legacy integrator and the compatibility
 * layer, which reproduce v1 bit for bit and need its surfaces exactly.
 *
 * v1 differs from the default venues in its arena: the net is flat at its
 * center height and stops only balls crossing toward +y; padel's side walls
 * are WALL_HEIGHT along their whole length; and lacrosse is a symmetric
 * 120 x 70 yd volume around midfield with only its center marked.
 */
const models_1 = require("../../models");
const freeze_1 = require("../freeze");
const features_1 = require("./features");
const frame_1 = require("./frame");
const racquet_1 = require("./racquet");
/** Left, right, far and near walls at the platform's edge, as v1 has them. */
function v1Walls(g) {
    if (g.WALL_HEIGHT === 0) {
        return [];
    }
    const end = g.TALL_WALL_HEIGHT !== 0 ? g.TALL_WALL_HEIGHT : g.WALL_HEIGHT;
    const { nearLeft, nearRight, farRight, farLeft } = (0, features_1.corners)(g.PLATFORM_WIDTH / 2, g.PLATFORM_LENGTH / 2);
    return [
        (0, features_1.wall)("leftWall", farLeft, nearLeft, g.WALL_HEIGHT, racquet_1.WALL_BOUNCE),
        (0, features_1.wall)("rightWall", nearRight, farRight, g.WALL_HEIGHT, racquet_1.WALL_BOUNCE),
        (0, features_1.wall)("farWall", farRight, farLeft, end, racquet_1.WALL_BOUNCE),
        (0, features_1.wall)("nearWall", nearLeft, nearRight, end, racquet_1.WALL_BOUNCE),
    ];
}
/** v1's net: flat at the center height, stopping balls from the trainer's side (-y) only. */
function v1Net(g) {
    if (g.NET_HEIGHT_CENTER === 0) {
        return [];
    }
    return [
        {
            id: "net",
            kind: "net",
            from: { x: -g.NET_WIDTH / 2, y: 0 },
            to: { x: g.NET_WIDTH / 2, y: 0 },
            bottom: 0,
            top: g.NET_HEIGHT_CENTER,
            faces: "right",
            response: racquet_1.NET_BOUNCE,
        },
    ];
}
function v1Stage(sport) {
    if (sport !== "LACROSSE") {
        return (0, racquet_1.racquetStage)(sport);
    }
    const { x, y } = (0, racquet_1.platformBounds)(models_1.CourtGeometryBySport[sport]);
    return { extents: { x, y }, features: { center: (0, features_1.point)(0, 0) } };
}
function buildV1Venue(sport) {
    const g = models_1.CourtGeometryBySport[sport];
    return {
        id: `v1/${sport}`,
        sport,
        stage: v1Stage(sport),
        arena: {
            bounds: (0, racquet_1.platformBounds)(g),
            ground: { restitution: models_1.DefaultPhysicalConstants.courtRestCoeff },
            panels: [...v1Walls(g), ...v1Net(g)],
        },
        frame: (0, frame_1.v1Frame)(sport),
    };
}
const V1_VENUES = (0, freeze_1.deepFreeze)(Object.fromEntries(models_1.Sports.map((sport) => [sport, buildV1Venue(sport)])));
/** v1's geometry for a sport, exactly: `requireProfile(model, sport, { venue: v1Venue(sport) })`. */
const v1Venue = (sport) => V1_VENUES[sport];
exports.v1Venue = v1Venue;
